'use strict';

/* Views */
import MailComposer from './mail/composer/mail-composer.component';
import MailList from './mail/list/mail-list.component';
import RecipientEdit from './mail/recipient/edit/mail-recipient-edit.component';
import RecipientList from './mail/recipient/list/mail-recipient-list.component';
import MailTemplateList from './mail/template/list/mail-template-list.component';
import MailTemplateEdit from './mail/template/edit/mail-template-edit.component';

/* Components */
import MailComposerSectionSelectorComponent from '../../components/mail-composer/section-selector/mail-composer-section-selector.component';
import MailComposerPreviewComponent from '../../components/mail-composer/preview/mail-composer-preview.component';
import MailComposerSendComponent from '../../components/mail-composer/send/mail-composer-send.component';
import MailArchiveSelectorComponent from '../../components/mail-composer/archive-selector/archive-selector.component';

/* Services */
import MailsService from '../../services/mails/mails.service';
import RecipientListService from '../../services/recipient-list/recipient-list.service';

export default angular.module('conduuApp.messaging', [MailComposer, RecipientEdit, RecipientList, MailList,
  MailComposerSectionSelectorComponent, MailComposerPreviewComponent, MailComposerSendComponent, MailArchiveSelectorComponent,
  MailsService, RecipientListService, MailTemplateList, MailTemplateEdit])
  .name;



// WEBPACK FOOTER //
// ./client/app/messaging/index.js